import gql from 'graphql-tag';
import { adSetFragment } from './adSetFragment';
export const competitionFragment = gql `
  fragment CompetitionWithAdAllocation on Competition {
    id
    name
    sport {
      id
      name
    }
    watermark {
      id
      url
      entityType
      entityId
    }
    secondaryWatermark {
      id
      url
      entityType
      entityId
    }
    logo {
      id
      url
      entityType
      entityId
    }
    adAllocation {
      id
      config {
        teams {
          home {
            enabled
            percentage
          }
          away {
            enabled
            percentage
          }
        }
        events
        loop {
          enabled
          type
          perPeriod
          secsPerShow
          secsBetweenShows
        }
      }
      adSets {
        ...AdSet
      }
    }
  }
  ${adSetFragment}
`;
//# sourceMappingURL=competition.js.map